import styles from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle';
import qs from 'qs';
import React from 'react';
import { toast } from 'sonner';

import { makeStyles } from '@material-ui/core/styles';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';
import ResetPasswordForm from 'components/ResetPasswordForm/ResetPasswordForm';

import { lookupPasswordResetToken } from 'utils/api';

const useStyles = makeStyles(styles);

const ResetPasswordPage = ({
  history, location, heading, subheading = '',
}) => {
  const classes = useStyles();
  const { token: passwordResetToken } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { LOGIN_ROUTE } = useAuthDataContext();

  // The email being used to register, returned from the backend
  const [email, setEmail] = React.useState('');

  // Admins can create accounts for users, but they still need to accept
  // the terms and conditions
  const [requireAcceptTerms, setRequireAcceptTerms] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      try {
        const data = await lookupPasswordResetToken(passwordResetToken);

        setEmail(data.email);
        setRequireAcceptTerms(data.requireAcceptTerms);
      } catch (error) {
        if (error.response.data.error) {
          if (error.response.data.error.includes('User not found')) {
            // The pasword reset token provided was invalid, so show an error and redirect to homepage
            toast.error('That password reset token is invalid!');

            // Redirect to the homepage
            history.replace('/');
          } else if (error.response.data.error.includes('Token already used')) {
            // The password reset token provided was already used, so redirect to login
            history.replace(LOGIN_ROUTE);
          }
        }
      }
    })();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.formContainer}>
        <ResetPasswordForm
          heading={heading}
          subheading={subheading}
          email={email}
          passwordResetToken={passwordResetToken}
          requireAcceptTerms={requireAcceptTerms}
        />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
